(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-menu"] && !Shopify.designMode) return;
  try {
    const syncHeaderMenuContext = () => {
    const activeContext = new URLSearchParams(window.location.search).get('from');

    document.querySelectorAll('.menu-list__link[data-menu-context]').forEach((link) => {
      link.classList.toggle('menu-list__link--active', link.dataset.menuContext === activeContext);
    });
  };

  syncHeaderMenuContext();
  document.addEventListener('shopify:section:load', syncHeaderMenuContext);
  } catch(e) { console.error(e); }
})();

})();
